import { render, staticRenderFns } from "./lectoParamsDownPc.vue?vue&type=template&id=0b3fd559&scoped=true"
import script from "./lectoParamsDownPc.vue?vue&type=script&lang=js"
export * from "./lectoParamsDownPc.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsDownPc.vue?vue&type=style&index=0&id=0b3fd559&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3fd559",
  null
  
)

export default component.exports